import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {RoadKillGameAssets} from "./RoadKillGameAssets";
import {RoadKillBackgroundElements} from "./view/RoadKillBackgroundElements";
import {RoadKillNormalBetPresentation} from "./gameflow/RoadKillNormalBetPresentation";
import {RoadKillNormalResultPresentation} from "./gameflow/RoadKillNormalResultPresentation";
import {RoadKillIdleNormalPresentation} from "./gameflow/RoadKillIdleNormalPresentation";
import {ISymbolValues, RoadKillGameData} from "./server/RoadKillData";
import {RoadKillModel} from "./server/RoadKillModel";
import {RoadKillGameMode} from "./server/RoadKillGameMode";
import {RoadKillReelsView} from "./reels/RoadKillReelsView";
import {RoadKillFreespinOutroView} from "./view/RoadKillFreespinOutroView";
import {RoadKillFreespinIntroView} from "./view/RoadKillFreespinIntroView";
import {RoadKillBigWinView} from "./view/RoadKillBigWinView";
import {RoadKillWinView} from "./view/RoadKillWinView";
import {RoadKillIdleRespinPresentation} from "./gameflow/RESPIN/RoadKillIdleRespinPresentation";
import {RoadKillRespinBetPresentation} from "./gameflow/RESPIN/RoadKillRespinBetPresentation";
import {RoadKillRespinResultPresentation} from "./gameflow/RESPIN/RoadKillRespinResultPresentation";
import {RoadKillWinCapView} from "./view/RoadKillWinCapView";
import {LifeView} from "./view/LifeView";
import {MovingCar} from "./view/MovingCar";
import {RoadKillSound} from "./sound/RoadKillSound";
import {RoadKillWinPresentation} from "./gameflow/RoadKillWinPresentation";
import {JumpingWildView} from "./view/JumpingWildView";
import {RoadKillWinToggle} from "./view/RoadKillWinToggle";
import {RoadKillBackgroundSpine} from "./view/RoadKillBackgroundSpine";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {RoadKillMassiveWinView} from "./view/RoadKillMassiveWinView";
import {TopAnimalController} from "./controller/TopAnimalController";
import {TopAnimalCounterView} from "./view/TopAnimalCounterView";
import {ParticlesManager} from "./particles/ParticlesManager";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TimelineLite} from "gsap";


export class RoadKill extends SlotGame {
    public static isActionSpinsActive: boolean = false;
    public static model: RoadKillModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: RoadKillSound;
    public static backgroundElements: RoadKillBackgroundElements;
    public static backgroundSpine: RoadKillBackgroundSpine;
    public static gameFlowController: GameFlowController;
    public static reelView: RoadKillReelsView;
    public static fsOutroView: RoadKillFreespinOutroView;
    public static fsIntroView: RoadKillFreespinIntroView;
    public static bigWinView: RoadKillBigWinView;
    public static initialWinView: RoadKillWinView;
    public static winCapView: RoadKillWinCapView;
    public static particleManager: ParticlesManager;

    // public static reelFrame: RoadKillReelFrame;
    public static lifeView: LifeView;
    public static jumpingWildView: JumpingWildView;
    public static movingCar: MovingCar;
    public static winToggle: RoadKillWinToggle;
    public static massiveWinView: RoadKillMassiveWinView;
    static topAnimalController: TopAnimalController;
    static topAnimalCounterView: TopAnimalCounterView;
    private _defaultSymbolValues: ISymbolValues = {
        "L1": {3: 0.3, 4: 0.4, 5: 0.8},
        "L2": {3: 0.25, 4: 0.35, 5: 0.7},
        "L3": {3: 0.2, 4: 0.3, 5: 0.6},
        "L4": {3: 0.2, 4: 0.3, 5: 0.6},
        "L5": {3: 0.2, 4: 0.3, 5: 0.6},
        "L6": {3: 0.2, 4: 0.3, 5: 0.6},
        "M1": {3: 0.75, 4: 2, 5: 4},
        "M2": {3: 0.5, 4: 0.75, 5: 2},
        "M3": {3: 0.45, 4: 0.6, 5: 1.5},
        "M4": {3: 0.4, 4: 0.55, 5: 1.25},
        "M5": {3: 0.35, 4: 0.5, 5: 1}
    }

    constructor() {
        super();
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.jpg">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(RoadKill.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
        if (RoadKill.model.initData.symbolValues) {
            symbolDataValueData = RoadKill.model.initData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, RoadKill.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("RoadKill could not load Paytable");
        });
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M3",
                    "L4",
                    "L3",
                    "M2",
                    "L1"
                ],
                [
                    "M4",
                    "M2",
                    "M3",
                    "M4",
                    "L4"
                ],
                [
                    "L4",
                    "M4",
                    "L2",
                    "M5",
                    "L4"
                ],
                [
                    "M1",
                    "S1",
                    "L4",
                    "M3",
                    "L2"
                ],
                [
                    "L4",
                    "L3",
                    "M4",
                    "L2",
                    "L3"
                ]
            ],
            "evaluatedArea": [
                [
                    "L4",
                    "L3",
                    "M2"
                ],
                [
                    "M2",
                    "M3",
                    "M4"
                ],
                [
                    "M4",
                    "L2",
                    "M5"
                ],
                [
                    "SW2",
                    "L4",
                    "M3"
                ],
                [
                    "L3",
                    "M4",
                    "L2"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "symbolSizes": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "wasFeatureBuy": false,
            "totalWays": 243,
            "brokeTheBank": false,
            "respinIndex": 0,
            "specialSymbolList": [
                {
                    "coordFrom": [
                        3,
                        0
                    ],
                    "sym": 13,
                    "symName": "SW2",
                    "multi": 1,
                    "respinCount": 0,
                    "getHitCount": 0,
                    "upgraded": false,
                    "alreadyGotHitThisSpin": false,
                    "gotHitThisSpinSecondTime": false,
                    "gotHitBySecondCar": false
                }
            ],
            "carInfo": [],
            "persistentMultiplier": 1,
            "heartList": [],
            "totalAnimalHits": 0,
            "doMassiveWildThisSpin": false,
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            RoadKill.model = new RoadKillModel(SlotGame.apiPlugin, true);
            RoadKill.gameFlowController = new GameFlowController(SlotGame.apiPlugin, RoadKill.model);
            RoadKill.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            RoadKill.model.events?.on(GameModelEvent.GAME, (data: RoadKillGameData) => {
                console.log(data);
            });

            const idleNormal: RoadKillIdleNormalPresentation = new RoadKillIdleNormalPresentation();
            const reelStart: RoadKillNormalBetPresentation = new RoadKillNormalBetPresentation();
            const normalResult: RoadKillNormalResultPresentation = new RoadKillNormalResultPresentation();

            const idleRespin: RoadKillIdleRespinPresentation = new RoadKillIdleRespinPresentation();
            const respinReelStart: RoadKillRespinBetPresentation = new RoadKillRespinBetPresentation();
            const respinResult: RoadKillRespinResultPresentation = new RoadKillRespinResultPresentation();

            const winPres: RoadKillWinPresentation = new RoadKillWinPresentation();

            RoadKill.gameFlowController.addGameModeFlowStatePresentationMap(RoadKillGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            RoadKill.gameFlowController.addGameModeFlowStatePresentationMap(RoadKillGameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleRespin],
                [FlowState.BET, respinReelStart],
                [FlowState.RESULT, respinResult],
                [FlowState.WIN, winPres]
            ]));
            RoadKill.gameFlowController.addGameModeFlowStatePresentationMap(RoadKillGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleRespin],
                [FlowState.BET, respinReelStart],
                [FlowState.RESULT, respinResult],
                [FlowState.WIN, winPres]
            ]));
            RoadKill.gameFlowController.addGameModeFlowStatePresentationMap(RoadKillGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleRespin],
                [FlowState.BET, respinReelStart],
                [FlowState.RESULT, respinResult],
                [FlowState.WIN, winPres]
            ]));


            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            AssetsConfig.addToAssetsConfig(RoadKillGameAssets.RESOURCES_GROUPS);
            RoadKill.assetLoader = new AssetLoader(RoadKill.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), RoadKill.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {
                this.createViewsAndComponents();
                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            SlotGame.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data === true) {
                    RoadKill.isActionSpinsActive = true;
                    RoadKill.winToggle.stopWinToggle();
                } else {
                    RoadKill.isActionSpinsActive = false;
                    const tl: TimelineLite = new TimelineLite();
                    tl.add(()=>{
                        RoadKill.jumpingWildView.reset();
                        RoadKill.lifeView.reset();
                        RoadKill.topAnimalController.reset();
                    })
                    tl.add(RoadKill.topAnimalController.getJWPopOutAnim()).progress(1);
                    tl.add(RoadKill.backgroundElements.updateMultiplier(1)).progress(1);
                }
            });
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        return super.start().then((value: NolimitPlugin) => {
            RoadKill.gameFlowController.start();
            RoadKill.soundPlayer.switchMusic(RoadKill.model.nextMode);
            RoadKill.massiveWinView.handleRestore();
            // SpineViewUtils.init(RoadKillGameAssets.RESOURCES_GROUPS.main, RoadKill.assetLoader);
            return value;

        });
    }

    private createViewsAndComponents() {
        //Non views
        RoadKill.soundPlayer = new RoadKillSound();

        //Static views
        RoadKill.particleManager = new ParticlesManager(RoadKill.assetLoader);
        RoadKill.backgroundElements = new RoadKillBackgroundElements();
        RoadKill.backgroundSpine = new RoadKillBackgroundSpine();
        RoadKill.backgroundSpine.changeBackground(RoadKill.model.data.nextMode);
        RoadKill.reelView = new RoadKillReelsView();
        RoadKill.fsOutroView = new RoadKillFreespinOutroView();
        RoadKill.fsIntroView = new RoadKillFreespinIntroView();
        RoadKill.bigWinView = new RoadKillBigWinView();
        RoadKill.initialWinView = new RoadKillWinView();
        RoadKill.winCapView = new RoadKillWinCapView();
        RoadKill.lifeView = new LifeView();
        RoadKill.jumpingWildView = new JumpingWildView();
        RoadKill.movingCar = new MovingCar();
        RoadKill.topAnimalCounterView = new TopAnimalCounterView();
        RoadKill.winToggle = new RoadKillWinToggle();
        RoadKill.massiveWinView = new RoadKillMassiveWinView();
        RoadKill.topAnimalController = new TopAnimalController();

        NolimitApplication.addLayerAt(RoadKill.winToggle.name, RoadKill.winToggle, 0);
        NolimitApplication.addLayerAt(RoadKill.winCapView.name, RoadKill.winCapView, 0);
        NolimitApplication.addLayerAt(RoadKill.initialWinView.name, RoadKill.initialWinView, 0);
        NolimitApplication.addLayerAt(RoadKill.bigWinView.name, RoadKill.bigWinView, 0);
        NolimitApplication.addLayerAt(RoadKill.fsOutroView.name, RoadKill.fsOutroView, 0);
        NolimitApplication.addLayerAt(RoadKill.fsIntroView.name, RoadKill.fsIntroView, 0);
        NolimitApplication.addLayerAt(RoadKill.topAnimalCounterView.name, RoadKill.topAnimalCounterView, 0);
        NolimitApplication.addLayerAt(RoadKill.movingCar.name, RoadKill.movingCar, 0);
        NolimitApplication.addLayerAt(RoadKill.massiveWinView.name, RoadKill.massiveWinView, 0);
        NolimitApplication.addLayerAt(RoadKill.jumpingWildView.name, RoadKill.jumpingWildView, 0);
        NolimitApplication.addLayerAt(RoadKill.lifeView.name, RoadKill.lifeView, 0);
        NolimitApplication.addLayerAt(RoadKill.reelView.name, RoadKill.reelView, 0);
        NolimitApplication.addLayerAt(RoadKill.backgroundElements.name, RoadKill.backgroundElements, 0);
        NolimitApplication.addLayerAt(RoadKill.backgroundSpine.name, RoadKill.backgroundSpine, 0);

    }
}